import { Immutable } from "immer";
import React from "react";

import { IProduct } from "../../../models/catalogue";
import { BasketLineColorOption } from "./BasketLineColorOption";
import { BasketLineWarrantyInfo } from "./BasketLineWarrantyInfo";

import styles from "./common.module.scss";

export const BasketLineOptions = (
    props: Immutable<{
        product: IProduct;
    }>,
): React.ReactNode => {
    return (
        <ul className={styles.optionsList}>
            <BasketLineColorOption product={props.product} />
            <BasketLineWarrantyInfo product={props.product} />
        </ul>
    );
};
